import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { AddQueueDialogComponent } from 'src/app/core/dialogs/add-queue-dialog/add-queue-dialog.component';
import { BtnCellRenderer } from 'src/app/core/grid/btn-cell-render.component';
import { ExcelService } from 'src/app/service/excel.service';
import { GroupIStateService } from 'src/app/service/groupi-state.service';
import { DomicileService } from 'src/app/service/kpi/domicile.service';
import { FormControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { startWith, map } from 'rxjs/operators';


@Component({
    selector: 'app-domicile',
    templateUrl: './domicile.component.html',
    styleUrls: ['./domicile.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None 
})
export class DomicileComponent implements OnInit {

  columnDefs;
  array: any;
  rowData;
  gridApi: any;
  currentPageNo: any;
  currentPageBoolean: boolean;
  rowCount: any;
  isLastPageFound: boolean;
  totalPage: any;
  currentPageForTotalPage: number;
  context: any;
  frameworkComponents: { btnCellRenderer: any; };
  icons: {};
  defaultColDef;
  displayRowData: any;
  updatedRows: any[];
  toprow: any;
  gridColumnApi: any;
  selected_position_id: number;
  selected_round_id: any;
  RoundData: any;
  TierData = [];
  selectedPeriod: number;
  successMessage = "";
  errorMessage = "";
  selectedDomiciles: any;
  optionalDomiciles: any;
  isAccessible = false;
  temp: any;
  KPI_WidgetsData = {
    id_TierPosition: null,
    id_Round: null,
    list_Domiciles: null,
    list_Users: null
  }

  domicileFilterCtrl: FormControl = new FormControl();
  filteredDomiciles: ReplaySubject<any[]> = new ReplaySubject(1);

  constructor(private readonly router: Router, public dialog: MatDialog, private readonly constants: Constants,
    private readonly excelService : ExcelService, private readonly domicileService: DomicileService, private readonly ngxUiLoaderService : NgxUiLoaderService, private readonly groupIStateService : GroupIStateService) {
    this.context = {
      componentParent: this
    };
    this.frameworkComponents = {
      btnCellRenderer: BtnCellRenderer
    };
    const tempKPI_WidgetsData = localStorage.getItem('KPI_WidgetsData');
    if (tempKPI_WidgetsData) {
      this.KPI_WidgetsData = JSON.parse(tempKPI_WidgetsData);
    }
  }

  ngOnInit(): void {
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.defaultColDef = {
      minWidth: 100,
      wrapText: true, resizable: true,
      floatingFilter: true, suppressMovable: true , suppressHeaderFilterButton: true ,suppressCellSelection: true
    };
    this.getColumnDefs()
    this.selectedPeriod = Number(localStorage.getItem("selectedPeriodId"))
    // this.checkRoles();
    this.domicileFilterCtrl.valueChanges
  .pipe(
    
    startWith(''),
    map(search => search ? this.filterDomiciles(search) : this.selectedDomiciles?.slice())
  )
  .subscribe(filtered => {
    this.filteredDomiciles.next(filtered);
  });
this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }
  async checkRoles() {
    await this.groupIStateService.getRoles();
    const roles = this.groupIStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
    //   if (userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin))
    //     this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // }
  }

  private filterDomiciles(search: string): any[] {
    const filterValue = search.toLowerCase();
    return this.selectedDomiciles.filter(d => d.label.toLowerCase().includes(filterValue));
  }
  

  defaultRowData() {
    this.toprow = [];
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData)
    this.updatedRows = [];
    this.rowCount = this.displayRowData.length;
  }

  onTierChange() {

    if (this.selected_position_id > 0) {

      this.KPI_WidgetsData.id_TierPosition = this.selected_position_id
      localStorage.setItem('KPI_WidgetsData', JSON.stringify(this.KPI_WidgetsData));
      this.ngxUiLoaderService.start(this.constants.LoaderComponent);

      this.domicileService.getRoundList(this.selectedPeriod, this.selected_position_id).subscribe(
        response => {
          this.selected_round_id = null;
          this.RoundData = response;
          if (response.length > 0) {
            this.selected_round_id = this.RoundData[0];

            this.selected_round_id = Number(this.KPI_WidgetsData.id_Round) > 0 ? Number(this.KPI_WidgetsData.id_Round) : 1
            this.onRoundChange()
          } else {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
            this.defaultRowData()
          }
        }, _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
          this.errorMessage = this.constants.APIErrorMessage;
          this.defaultRowData()
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      );
    }
  }


  onRoundChange() {
    if (this.selected_round_id) {
      this.KPI_WidgetsData.id_Round = this.selected_round_id
      localStorage.setItem('KPI_WidgetsData', JSON.stringify(this.KPI_WidgetsData));
    }

    this.getDomiciles();
  }

 IDValueFormatter(params) {
    let displayValue;

    if (params.data?.ALARM_ID == "null")  // NOSONAR
      {displayValue = "";}
    else
    {  displayValue = params.data?.ALARM_ID;}

    return displayValue;
  }

  getColumnDefs() {
    this.columnDefs = [
      {
        headerName: "ID", field: "ALARM_ID", minWidth: 55, maxWidth: 55, floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', pinned: 'left', valueFormatter: this.IDValueFormatter
      },
      {
        headerName: "Alarm", field: "ALARM", minWidth: 500, maxWidth: 500, cellClass: "left_align", autoHeight: true, pinned: 'left'
      },
      {
        headerName: "Total", field: "'TOTAL'", minWidth: 120, maxWidth: 120, autoHeight: true, pinned: 'left'
      }
    ];
  }

  getDomiciles() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    this.domicileService.getDomicileList(this.selectedPeriod, Number(this.selected_position_id), this.selected_round_id).subscribe(
      response => {
        this.selectedDomiciles = [];
        if (response.length > 0) {
          const temp = response.sort((a, b) => (a.domicile_code < b.domicile_code ? -1 : 1));

          temp.forEach(element => {
          
          const  obj = { "label": element.domicile_code, "value": element.domicile_code };
            this.selectedDomiciles.push(obj);
          });
          this.optionalDomiciles = this.selectedDomiciles

          const tempOptionalDomiciles = this.KPI_WidgetsData.list_Domiciles?.split(",")
          if (tempOptionalDomiciles) {
            const tempFinalOptionalDomiciles = []
            tempOptionalDomiciles.forEach(element => {
              const objOptionalDomicile = this.optionalDomiciles.find(x => x.label == element)  // NOSONAR
              if (objOptionalDomicile)
                {tempFinalOptionalDomiciles.push(objOptionalDomicile)}
            })
            this.optionalDomiciles = tempFinalOptionalDomiciles
          }
          this.onDomicileChange();
        }
        else {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
          this.defaultRowData()
          this.getColumnDefs()
        }
        console.info(this.selectedDomiciles)
        this.filteredDomiciles.next(this.selectedDomiciles?.slice());

      },
      _error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
        this.errorMessage = this.constants.APIErrorMessage;
        this.getColumnDefs()
        this.defaultRowData()
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);
      }

    )
  }

  RefreshData() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);

    this.domicileService.getGridData(this.selectedPeriod, Number(this.selected_position_id), Number(this.selected_round_id), this.optionalDomiciles?.map(x => x.

      value).toString()).subscribe(
        response => {
          if (response.length > 0) {
            this.temp = JSON.parse(response)
            this.displayRowData = JSON.parse(JSON.stringify(this.temp))
            this.toprow = [];
            for (let i = 0; i < 2; i++) {
              this.toprow.push(this.displayRowData[i]);
            }
            this.toprow[1]["'TOTAL'"] = this.toprow[1]["'TOTAL'"] == "00%" || this.toprow[1]["'TOTAL'"] == "0%" ? "0.00%" : this.toprow[1]["'TOTAL'"]  // NOSONAR
            this.optionalDomiciles.forEach(element => {
              this.toprow.forEach(x => { x[`'${element.value}'`] = x[`'${element.value}'`] == "00%" || x[`'${element.value}'`] == "0%" ? "0.00%" : x[`'${element.value}'`] }) // NOSONAR
            });
            this.toprow[1]["'LTL'"] = this.toprow[1]["'LTL'"] == "00%" || this.toprow[1]["'LTL'"] == "0%" ? "0.00%" : this.toprow[1]["'LTL'"]  // NOSONAR
            this.displayRowData.splice(0, 2)
            this.gridApi?.setGridOption('rowData', this.displayRowData)
            this.updatedRows = [];
            this.rowCount = this.displayRowData.length;
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
          } else {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
            this.defaultRowData()
          }
        },
        _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
          this.errorMessage = this.constants.APIErrorMessage;
          this.defaultRowData()
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      )
  }

  onDomicileChange() {
    this.columnDefs = []
    this.KPI_WidgetsData.list_Domiciles = this.optionalDomiciles?.map(x => x.value).toString()
    localStorage.setItem('KPI_WidgetsData', JSON.stringify(this.KPI_WidgetsData));
    this.getColumnDefs()
    this.optionalDomiciles?.forEach(element => {
     const obj = { headerName: element.value, field: "'" + element.value + "'", width: 120, sortable: true, unSortIcon: true, autoHeight: true }
      this.columnDefs.push(obj);
    })
    
   const ltl = { headerName: "LTL", field: "'LTL'", width: 90, sortable: true, unSortIcon: true, autoHeight: true }
    this.columnDefs.push(ltl)
    this.RefreshData();
  }

  SizeToFit() { this.gridApi?.sizeColumnsToFit(); }
  OnGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();

  }
  OnPageSizeChanged(event: any) {
    if (event.target.value == "ALL")  // NOSONAR
      {this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length));}
    else
     { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); }
  }
  GoToNexpage() { this.gridApi.paginationGoToNextPage(); }

  GoToPreviousPage() { this.gridApi.paginationGoToPreviousPage()  }

  GoToFirstPage() { this.gridApi.paginationGoToFirstPage(); }

  GoToLastPage() { this.gridApi.paginationGoToLastPage()  }

  GetCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  IsLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  AddToQueue(): void {
    const dialogRef = this.dialog.open(AddQueueDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '240px',
      data: {
        header: 'Add To Queue',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      if (result.event == 'SaveEvent') {  // NOSONAR
        if (result.data == "Success") {  // NOSONAR
          this.successMessage = this.constants.APIAddToQueueSuccess;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      }
    });

  }

  onBtExport() {
    if (this.temp?.length > 0) {
      const exportData = [];
      let obj;
      this.temp.forEach(e => {
        obj = {
          id: e.ALARM_ID,
          alarm: e.ALARM,
          total: e["'TOTAL'"]
        };

        this.selectedDomiciles.forEach(element => {
          obj[element.label] = e[`'${element.label}'`]
        });

        obj["ltl"] = e["'LTL'"]

        exportData.push(obj);
      });


      const headers = ['ID', 'ALARM', 'TOTAL'];
      this.selectedDomiciles.forEach(e => {
        headers.push(e.label);
      })
      headers.push("LTL")

      this.excelService.exportAsExcelFile(exportData, 'DOMICILE-KPI - ' + localStorage.getItem("selectedPeriodValue"), headers);
    }
  }

  openRouteLevel(route) {

    this.router.navigate([`${route}`]);
  }


  componentEventHandler(event) {

    if (event.eventType == "CHANGE_PERIOD") {  // NOSONAR
      this.selectedPeriod = event.periodId


      if (this.selectedPeriod) {
        this.ngxUiLoaderService.start(this.constants.LoaderComponent);
        this.domicileService.getTierList(this.selectedPeriod).subscribe(
          response => {
            this.selected_position_id = null;
            this.TierData = response;
            if (response.length > 0) {
              this.selected_position_id = this.TierData[0].tierPosition;
              this.selected_position_id = Number(this.KPI_WidgetsData.id_TierPosition) > 0 ? Number(this.KPI_WidgetsData.id_TierPosition) : 1
              this.onTierChange()


            }
            else {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
              this.defaultRowData()
            }
          },
          _error => {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
            this.errorMessage = this.constants.APIErrorMessage;
            this.defaultRowData()
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
          }
        );
      }

    }
  }

  isAllSelected(): boolean {
    return this.optionalDomiciles?.length == this.selectedDomiciles?.length;  // NOSONAR
  }
  
  isIndeterminate(): boolean {
    return this.optionalDomiciles?.length > 0 &&
           this.selectedDomiciles?.length > 0 &&
           this.selectedDomiciles?.length < this.optionalDomiciles?.length;
  }
  
  toggleSelectAll(event: any): void {
    if (event.checked) {
      this.optionalDomiciles = [...this.selectedDomiciles];
    } else {
      this.optionalDomiciles = [];
    }
    this.onDomicileChange(); 
  }



}

